// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import {getAuth} from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyCK1mxcquKFCMBf9mi47qBeaYxXFhacZlw",
    authDomain: "personal-portfolio-e2184.firebaseapp.com",
    projectId: "personal-portfolio-e2184",
    storageBucket: "personal-portfolio-e2184.appspot.com",
    messagingSenderId: "941258948116",
    appId: "1:941258948116:web:9e7de0c951d6c557c37101",
    measurementId: "G-TMPDLRZG0W"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

const auth = getAuth();

export {auth};
